// extracted by mini-css-extract-plugin
export default {"text":"gNhb35XF6YFt7I0Ll4RG"};